import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["input"]

    sanitize(event) {
        const input = event.target
        if (input.value) {
            const url = new URL(input.value, window.location.origin)
            if (url.search) {
                input.value = input.value.split('?')[0]
                // Trigger input event to ensure other controllers (like validation) are updated
                input.dispatchEvent(new Event('input', { bubbles: true }))
            }
        }
    }
}
